

































































































import Enumerable from "linq";
import { DialogMixin, ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { Component, Mixins } from "vue-property-decorator";
import { FormatStructureEditableMixin } from "../../../mixins";
import { ExpressionFunctionKinds, ExpressionKinds, ExpressionOperatorKinds, ExpressionReferenceKinds, ICalculationExpressionContent, ICalculationExpressionObjectReference, IDateCalculateItem, instanceOfIDateCalculateNumber } from "../../../../../../../documaker/domain/format/objects";
import { NumberInput } from "../../../../../../../base/components/system";
import { CalculationExpressionSelector } from "../selectors";

@Component({
  components: {
    NumberInput,
    CalculationExpressionSelector,
  },
})
export default class CalculationExpressionEditDialog extends Mixins(DialogMixin, ModelEditableMixin, FormatStructureEditableMixin) {
  settableItems: ICalculationExpressionContent[] = [];
  settingCalculateExpressionItems: ICalculationExpressionContent[] = [];
  selectedSettableItems: ICalculationExpressionContent[] = [];
  selectedSettingItems: ICalculationExpressionContent[] = [];
  edittingCalculationNumber: number = null;
  confirmSelected: boolean = false;
  isTextEnable: boolean = true;
  isCheckEnable: boolean = false;
  isCircleSelectEnable: boolean = false;
  isComboEnable: boolean = false;
  isRollEnable: boolean = false;
  isCalculationEnable: boolean = false;
  isConditionalEnable: boolean = false;
  isDateDurationEnable: boolean = false;
  isTimeSpanEnable: boolean = false;

  get hasEdittingCalculationNumber(): boolean {
    return !!this.edittingCalculationNumber || (this.edittingCalculationNumber === 0);
  }

  get hasSelectedSettableItems(): boolean {
    return (this.selectedSettableItems.length > 0);
  }

  get hasSelectedSettingItems(): boolean {
    return (this.selectedSettingItems.length > 0);
  }

  get isTopSelectedItem(): boolean {
    return this.selectedSettingItems.some(v => v === this.settingCalculateExpressionItems[0]);
  }

  get isBottomSelectedItem(): boolean {
    return this.selectedSettingItems.some(v => v === this.settingCalculateExpressionItems[this.settingCalculateExpressionItems.length - 1]);
  }

  get filterSettableItems(): ICalculationExpressionContent[] {
    return Enumerable.from(this.settableItems).where(s => {
      const type = (s.reference as ICalculationExpressionObjectReference).type;
      return (this.isTextEnable && ((type === "tag") || (type === "text") || (type === "script") || (type === "scriptlink")))
      || (this.isCheckEnable && (type === "check"))
      || (this.isCircleSelectEnable && (type === "circleselect"))
      || (this.isComboEnable && (type === "combo"))
      || (this.isRollEnable && (type === "roll"))
      || (this.isCalculationEnable && (type === "calculate") && (s.reference as ICalculationExpressionObjectReference).expressionKind === ExpressionKinds.Calculation)
      || (this.isConditionalEnable && (type === "calculate") && (s.reference as ICalculationExpressionObjectReference).expressionKind === ExpressionKinds.Conditional)
      || (this.isDateDurationEnable && (type === "calculate") && (s.reference as ICalculationExpressionObjectReference).expressionKind === ExpressionKinds.DateDuration)
      || (this.isTimeSpanEnable && (type === "calculate") && (s.reference as ICalculationExpressionObjectReference).expressionKind === ExpressionKinds.TimeSpan);
    }).toArray();
  }

  get previewText(): string {
    let text = "";
    let index = 0;
    Enumerable.from(this.settingCalculateExpressionItems).forEach(s => {
      index += 1;
      for (let i = 0; i < s.brackets.openCount; i++) {
        text += "(";
      }
      text += s.name;
      if (s.kind === ExpressionReferenceKinds.Object
        && !!(s.reference as ICalculationExpressionObjectReference).subKey) {
          text += "_" + (s.reference as ICalculationExpressionObjectReference).subKey;
      }
      for (let i = 0; i < s.brackets.closeCount; i++) {
        text += ")";
      }
      if (index !== this.settingCalculateExpressionItems.length
        && s.kind !== ExpressionReferenceKinds.Function) {
        text += " " + this.getOperatorText(s.operator) + " ";
      }
    });
    return text;
  }
  private getOperatorText(kind: ExpressionOperatorKinds): string {
    switch (kind) {
      case ExpressionOperatorKinds.Add: return "+";
      case ExpressionOperatorKinds.Subtract: return "-";
      case ExpressionOperatorKinds.Multiply: return "×";
      case ExpressionOperatorKinds.Divide: return "÷";
      case ExpressionOperatorKinds.Power: return "^";
      case ExpressionOperatorKinds.Root: return "√";
      default: return "";
    }
  }

  async show(settableItems: ICalculationExpressionContent[], settingItems: ICalculationExpressionContent[]): Promise<ICalculationExpressionContent[]> {
    return this.showModal(async () => {
      this.settableItems = settableItems;
      this.settingCalculateExpressionItems = settingItems;
      this.confirmSelected = false;
      await this.waitHidden();
      return this.confirmSelected ? this.settingCalculateExpressionItems : null;
    });
  }

  addCalculationNumber() {
    this.settingCalculateExpressionItems = this.settingCalculateExpressionItems.concat({
      kind: ExpressionReferenceKinds.Fixed,
      reference: this.edittingCalculationNumber,
      operator: ExpressionOperatorKinds.Add,
      brackets: {
        openCount: 0,
        closeCount: 0,
      },
      name: this.edittingCalculationNumber.toString(),
    });
  }

  addCalculationRootFunction() {
    this.settingCalculateExpressionItems = this.settingCalculateExpressionItems.concat({
      kind: ExpressionReferenceKinds.Function,
      reference: ExpressionFunctionKinds.Root,
      operator: ExpressionOperatorKinds.Root,
      brackets: {
        openCount: 0,
        closeCount: 0,
      },
      name: "√",
    });
  }

  addCalculationNaturalLogarithmFunction() {
      this.settingCalculateExpressionItems = this.settingCalculateExpressionItems.concat({
      kind: ExpressionReferenceKinds.Function,
      reference: ExpressionFunctionKinds.NaturalLogarithm,
      operator: ExpressionOperatorKinds.Add,
      brackets: {
        openCount: 0,
        closeCount: 0,
      },
      name: "LN",
    });
  }

  addCalculationObject() {
    this.settingCalculateExpressionItems = this.settingCalculateExpressionItems.concat(
      Enumerable.from(this.selectedSettableItems).select(s => {
        const reference = s.reference as ICalculationExpressionObjectReference;
        return {
          kind: ExpressionReferenceKinds.Object,
          reference: {
            type: reference.type,
            id: reference.id,
            key: reference.key,
            subKey: reference.subKey,
            expressionKind: reference.expressionKind,
            alternativeValue: reference.alternativeValue,
          },
          operator: s.operator,
          brackets: {
          openCount: s.brackets.openCount,
          closeCount: s.brackets.closeCount,
          },
          name: s.name,
        };
      }).toArray());
  }

  settableItemSelectionChange(value: ICalculationExpressionContent[]) {
    this.selectedSettableItems = value;
  }

  settingItemsSelectionChange(value: ICalculationExpressionContent[]) {
    this.selectedSettingItems = value;
  }

  moveItems(offset: number) {
    const indexes = this.selectedSettingItems.map(v => this.settingCalculateExpressionItems.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.settingCalculateExpressionItems[index];
    this.settingCalculateExpressionItems.splice(index, 1);
    this.settingCalculateExpressionItems.splice(index + offset, 0, item);
  }

  removeItems() {
    this.settingCalculateExpressionItems = this.settingCalculateExpressionItems.filter((v) => !this.selectedSettingItems.some(s => s === v));
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }

  toDateCalculateItemName(row: IDateCalculateItem): string {
    return instanceOfIDateCalculateNumber(row.reference) ? "固定日数" : row.reference.name;
  }
}
